export const OBJECT_ARRAY_FLAG = '____arr-obj';
export const OBJECT_ARRAY_CNT = '____arr-obj-cnt';
export const SPEC_TYPE_FOR_GENERATE_BUTTON = ['base', 'password', 'textarea'];
export const EMPTY_MUTATOR = '____empty-mutator';
